import React from 'react'
import { Route } from 'react-router'
const SubscriptionTrialSelection = React.lazy(() => import('./subscription-trial-selection'))

const subscriptionRoutes = (
  <>
    <Route path='subscription/trials' element={<SubscriptionTrialSelection context='trialSelect' />} />
  </>
)

export default subscriptionRoutes
